import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { getActiveCommunity } from './utility/activeCommunity'

export const honeybadger = Honeybadger.configure({
  apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
  environment: process.env.NODE_ENV,
})

const HoneybadgerProvider = ({ children }) => {
  const user = useSelector(state => state.user.current_user)
  const activeCommunityId = useSelector(state => state.user.active_community_id)

  useEffect(() => {
    if (user) {
      const activeCommunity = getActiveCommunity(user)
      const community = activeCommunity ? { id: activeCommunity.id, name: activeCommunity.name } : undefined

      honeybadger.setContext({
        user_id: user.id,
        user_type: user.type,
        user_email: user.email,
        username: user.username,
        community,
      })
    } else {
      honeybadger.clear()
    }
  }, [user, activeCommunityId])

  return (
    <HoneybadgerErrorBoundary honeybadger={honeybadger}>
      {children}
    </HoneybadgerErrorBoundary>
  )
}

HoneybadgerProvider.propTypes = {
  children: PropTypes.object,
}

export default HoneybadgerProvider
